import { Component, OnInit } from '@angular/core';
import { DataService, Command, State } from '../shared/dataService';
import { UserInfo, UserInfoSynchronize, UserInfoGeneralSynchronize, IUserMSGModel, PersonBioTemplate } from '../shared/interfaces/userInfo';
import notify from 'devextreme/ui/notify';
import { Device } from '../shared/interfaces/deviceInfo';
@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})


export class UserInfoComponent implements OnInit {
  showFirstSubmenuModes: any;
  showSubmenuModes: any;
  checkBoxesMode: string;
  bUserPIN: string;

  public privileges :State[];
  public listdevices : Device[];
  public personBioTemplate : PersonBioTemplate[];
  public updateUser : UserInfo;
  public selectedRowsDataUser: Array<string>  = [];
  public selectedRowsDataDevice :Array<string>  = [];
  public popupSynchronizeFingerprint : boolean = false;
  public popupSynchronizeUser : boolean = false;
  public popupBioTemplate : boolean = false;
  sendCommand:boolean =false;
  //datos del usuario seleccionado
  public selectedUser :UserInfo = 
        {
          userPin: "",
          userName: "",
          countDevicesSN: 0,
          privilege: 0,
          mainCard: "",
          privilegeString :"",
          deviceSN: ""

        }
  //END datos del usuario seleccionado
  public userInfoSynchronize  :UserInfoSynchronize  = 
  {
    DevicesSN : [],
    UserPin : []
  };

  public  states: State[] = [{
            "ID": 0,
            "Name": "Common User"
        }, {
            "ID": 6,
            "Name": "Administrator"
        }, {
          "ID": 14,
          "Name": "Super Administrator"
      }];
  public  msgType = [{
          "ID": 253,
          "Name": "Publico"
      }, {
          "ID": 254,
          "Name": "Privado"
      }];      
  public  mensajes = [
      {"ID": 1,"Name": "Buenos días"}, 
      {"ID": 2,"Name": "Hola Sistemas"},
      {"ID": 3,"Name": "Hola Infraestructura"},
      {"ID": 4,"Name": "Hola Desarrollo"}, 
      {"ID": 5,"Name": "¡Feliz Cumpleaños!"},
      {"ID": 6,"Name": "¡Feliz Aniversario!"},
      {"ID": 7,"Name": "Favor de pasar a RRHH"},
      {"ID": 8,"Name": "¡Feliz Navidad!"},
      {"ID": 9,"Name": "¡Feliz Año Nuevo!"},
  ]; 
  public vMensaje = true;

  public commands : Command[];
  public dataSource: UserInfo[];
  public userInfoGeneralSynchronize: UserInfoGeneralSynchronize =  {
    userInfoGeneral :
    {
      userPin : "",
      privilege: 0,
      name : "",
      password : "",
      viceCard : "",
      mainCard: "",
      accGroupId : 0
    },
    devicesSN : []
  };
  public IUserMSGModel: IUserMSGModel =  {
    userPin: "",
    password: "",
    messageId: 0,
    message: "",
    type: 0,
    duration: 30,
    startTime: null,
    deviceSN: ""
  };
  constructor(private data : DataService) 
  {
    this.showSubmenuModes = [{
      name: "onHover",
      delay: { show: 0, hide: 500 }
  }, 
  {
      name: "onClick",
      delay: { show: 0, hide: 300 }
  }];
  this.showFirstSubmenuModes = this.showSubmenuModes[1];
  this.checkBoxesMode = 'onClick';
  this.commands = data.getUserCommands;

  this.showBioTemplates = this.showBioTemplates.bind(this);
  }

  public allMode = 'page';
  public editorOptions: boolean ;
  //public checkBoxesMode = 'always'; //"onClick" | "onLongTap" | "always"
  ngOnInit() 
  { 
    //alert(25);
    //this.loadBioTemplates();
    this.loadUserInfo(); 
    this.loadDevices();
    this.allMode = 'allPages';
    this.editorOptions = true;
  }

  loadUserInfo()
  {
    this.data.getUsersInfo()
              .subscribe(success=> 
                {
                    if(success)
                    {
                      this.dataSource = this.data.userInfo;
                      console.log(this.data.userInfo)
                      //change name to privilege
                      /*  0       Normal user    
                        2       Registrar    
                        6       Administrator    
                        10      User-defined    
                        14      Super administrator   **/
                        // this.dataSource.forEach(element => 
                        //   {
                        //     if(element.privilege==0)
                        //       element.privilegeString = "Normal";
                        //     else
                        //       if(element.privilege==6)
                        //         element.privilegeString = "Administrator";
                        //       else
                        //         element.privilegeString = "Normal-";

                        // });
                    }
              },error=>
                {
                  console.log("error:")
                  console.log( error);
                })
  }
  loadDevices()
  {
    this.data.loadDevices()
    .subscribe(success=>
    {
      if(success)
      {
        this.listdevices= this.data.devices;
        //console.log(this.listdevices);
      }
    },error=>
    {
      console.log(error);
    });
  }
  loadBioTemplates(userPin)
  {
    this.data.loadBioTemplates(userPin)
    .subscribe(success=>
    {
      if(success)
      {
        this.personBioTemplate= this.data.personBioTemplates;

      for(var i=0; i<this.personBioTemplate.length; i++){
        this.personBioTemplate[i].bioTypeName=this.getBioTypeName(this.personBioTemplate[i].bioType);
      }

        console.log(this.personBioTemplate);
      }
    },error=>
    {
      console.log(error);
    });
  }
  getBioTypeName(bioType){
    var name = ""
    switch(bioType){
      case 1: name = "Huella"; break;
      case 2: name = "Rostro"; break;
      case 8: name = "Palma"; break;
      case 9: name = "Rostro"; break;
    }
    return name;
  }  
  OnRowUpdated(e)
  {
      console.log(e);
      //this.data.updateDeviceBySN("BOCB182460271");
      
      this.data.updateUserInfo(e.data)
      .subscribe(sucess => 
          {
              if (sucess)
              { 
                  this.updateUser = this.data.updateUser;
                  console.log(this.updateUser);
                  this.loadUserInfo();
              }
          }  
      );
      
      console.log("terminar de editar");
  }
  addHours(date, hours) {
    date.setHours(date.getHours() + hours);
  
    return date;
  }
  onSynchronizeEditUserCommand()
  { 

       //validar que la tabla de los dispositivos no este vacía
       if(this.selectedRowsDataDevice != undefined &&
        this.selectedRowsDataDevice.length > 0)
      { 
        console.log("enviar datos"); 
        console.log(this.selectedUser);
       /*
          int PSM = 253; //Public short message
          int USM = 254; //User short message
          int RSM = 255; //Reserved short message
        */
        console.log(this.IUserMSGModel);
        this.IUserMSGModel.message = this.mensajes.find(e => e.ID == Number(this.IUserMSGModel.messageId)).Name;
        this.IUserMSGModel.deviceSN = this.selectedRowsDataDevice.toString();
        this.IUserMSGModel.userPin = this.selectedUser.userPin;
        var d = this.IUserMSGModel.startTime;
        this.IUserMSGModel.startTime = this.addHours(d, -6); //Quick fix
        console.log(this.IUserMSGModel);
        //return false;
        this.data.SendShortMSG(this.IUserMSGModel)
        .subscribe(success=> 
          {
              if(success)
              {
                console.log("subscribe success: "+ success);
                this.loadUserInfo();
              }
        },error=>
          { 
            console.log( error); 
          })
      }
      
    this.popupSynchronizeUser = false;
  }
  onSynchronizeFingerprintCommand()
  {
    //validar que la tabla de los dispositivos no este vacía
    if(this.selectedRowsDataDevice != undefined &&
      this.selectedRowsDataDevice.length > 0)
    {
      //enviar los dispositivos con los usuarios.
      console.log("enviar datos");
      this.data.commandSynchronizeFingerpringCommand(this.userInfoSynchronize)
      .subscribe(success=> 
        {
            if(success)
            {
              this.dataSource = this.data.userInfo; 
            }
      },error=>
        {
          console.log("error:")
          console.log( error);
        })
    }
    this.loadDevices(); this.loadUserInfo();
    this.popupSynchronizeFingerprint = false;
  }

  onSynchronizeGetBiometria()
  {
    //validar que la tabla de los dispositivos no este vacía
    if(this.selectedRowsDataDevice != undefined &&
      this.selectedRowsDataDevice.length > 0)
    {
      //enviar los dispositivos con los usuarios.
      console.log("enviar datos");
      this.data.GetUserBio(this.userInfoSynchronize)
      .subscribe(success=> 
        {
            if(success)
            {
              this.dataSource = this.data.userInfo; 
            }
      },error=>
        {
          console.log("error:")
          console.log( error);
        })
    }
    this.loadDevices(); this.loadUserInfo();
    this.popupSynchronizeFingerprint = false;
  }  

  onSynchronizeBiometria()
  {
    //validar que la tabla de los dispositivos no este vacía
    if(this.selectedRowsDataDevice != undefined &&
      this.selectedRowsDataDevice.length > 0)
    {
      //enviar los dispositivos con los usuarios.
      console.log("enviar datos");
      this.data.delUserBio(this.userInfoSynchronize)
      .subscribe(success=> 
        {
            if(success)
            {
              this.dataSource = this.data.userInfo; 
            }
      },error=>
        {
          console.log("error:")
          console.log( error);
        })
    }
    this.loadDevices(); this.loadUserInfo();
    this.popupSynchronizeFingerprint = false;
  }  

  onSynchronizeBorraUsuario()
  {
    //validar que la tabla de los dispositivos no este vacía
    //if(this.selectedRowsDataDevice != undefined && this.selectedRowsDataDevice.length > 0){
      //enviar los dispositivos con los usuarios.
      console.log("enviar datos");
      this.data.delUserAD(this.userInfoSynchronize)
      .subscribe(success=> 
        {
            if(success)
            {
              this.dataSource = this.data.userInfo; 
            }
      },error=>
        {
          console.log("error:")
          console.log( error);
        })
    //}
    this.loadDevices(); this.loadUserInfo();
    this.popupSynchronizeFingerprint = false;
  }  

  onResetPassword()
  {
    //validar que la tabla de los dispositivos no este vacía
    if(this.selectedRowsDataDevice != undefined &&
      this.selectedRowsDataDevice.length > 0)
    {

      console.log("enviar datos"); 
      console.log(this.selectedUser);
     /*
        int PSM = 253; //Public short message
        int USM = 254; //User short message
        int RSM = 255; //Reserved short message
      */
      console.log(this.IUserMSGModel);
      //this.IUserMSGModel.message = this.mensajes.find(e => e.ID == Number(this.IUserMSGModel.messageId)).Name;
      this.IUserMSGModel.startTime = new Date(); //Solo para no enviar nulos
      this.IUserMSGModel.deviceSN = this.selectedRowsDataDevice.toString();
      this.IUserMSGModel.userPin = this.selectedUser.userPin;
      this.IUserMSGModel.password = this.password;
      //enviar los dispositivos con los usuarios.
      console.log("enviar datos");
      this.data.commandResetPassword(this.IUserMSGModel)
      .subscribe(success=> 
        {
            if(success)
            {
              this.dataSource = this.data.userInfo; 
            }
      },error=>
        {
          console.log("error:")
          console.log( error);
        })
    }
    this.loadDevices(); this.loadUserInfo();
    this.popupSynchronizeFingerprint = false;
  }  

  popupSendEditUserClick(e)
  {
    
    if(this.selectedRowsDataUser != undefined &&
      this.selectedRowsDataUser.length > 0)
    {
      console.log(this.selectedRowsDataUser.length)
      if(this.selectedRowsDataUser.length > 1 )
      {
        console.log("mas de un usuario selececcionado");
        return;
      }
      this.popupSynchronizeUser = true;
    }
    //this.popupSynchronizeUser = true;
  }

  popupSendClick() 
  {
    if( this.selectedRowsDataUser != undefined  && 
        this.selectedRowsDataUser.length > 0)
    {
      this.popupSynchronizeFingerprint = true;
      //notify("The Send button was clicked");  
    }

    
  }

  logEvent(eventName,event,nameGrid: string)
  {
    console.log("eventNanme:"+ eventName);
    console.log(event);
      switch (eventName) {
        case 'edit':
          
          break;
      case'onSelectionChanged':
        this.onSelectionChanged(event,nameGrid);
       break;
      case 'onRowUpdated':
        this.OnRowUpdated(event);
        break;
      default:

          break;
      }

  }
  /*
  itemClick(data)
  {
    console.log(data);
  }
  */
  public popupTitle = "";
  public popupcmd = "";
  public password = "";
  public vDevices = true;
  itemClick(data)
    {
        //validar que tenga dispositvos selccionados 
        if(data.itemData.command != undefined)
        {
          if(data.itemData.command != 'mensaje'){
            if( this.selectedRowsDataUser == undefined || this.selectedRowsDataUser.length == 0){
              notify("Favor de seleccionar un usuario");
              return false;  
            }
          }
          this.vDevices = true;
          this.popupcmd = data.itemData.command;
            switch (data.itemData.command) 
            {
                case 'TransfUsuario':
                  this.popupTitle = "Transferir Usuarios";
                  console.log("Transfiere Usuarios");
                  this.popupSynchronizeFingerprint = true;
                  break;
                case 'TraeBiometria':
                  this.popupTitle = "Obtener Biometrias";
                  console.log("Obtener Biometrias");
                  this.popupSynchronizeFingerprint = true;
                  break;                  
                case'BorraBiometria':
                  this.popupTitle = "Borrar Biometrias";
                  console.log("BorraBiometria");
                  this.popupSynchronizeFingerprint = true;
                  break;
                case'BorraUsuario':
                  this.popupTitle = "Borrar Usuarios";
                  console.log("BorraUsuario");
                  this.vDevices = false;
                  this.popupSynchronizeFingerprint = true;
                  break;                  
                case'ResetPassword':
                  this.popupTitle = "Cambiar Contraseña";
                  this.password = "";
                  console.log("ResetPassword");
                  this.popupSynchronizeFingerprint = true;
                  break;
                case'mensaje':
                  this.vMensaje=true;
                  //console.log("enviaMensaje");
                  this.IUserMSGModel.startTime = new Date();
                  //this.IUserMSGModel.type = 253;
                  this.popupSynchronizeUser = true;
                  break;
                case'mensajeUsuario':
                  this.vMensaje=false;
                  //console.log("enviaMensaje");
                  this.IUserMSGModel.startTime = new Date();
                  //this.IUserMSGModel.type = 254;
                  this.IUserMSGModel.type = 0;
                  this.popupSynchronizeUser = true;
                  break;                 
                /*case'devInfo':
                    this.onDevInfo();
                break;*/
                default:
                console.log("comando no registrado");
                    break; 
            }
            //console.log(data.itemData.command);
        }
    } 
  onSelectionChanged(event: any,nameGrid: string) 
  { 
    if(event.selectedRowsData.length ===0)
      if(nameGrid == 'devicesInfoGrid')
      { 
          this.selectedRowsDataDevice = [];
      }
      else
      {
        this.selectedRowsDataUser =[];
      }
    let index = 0;
    event.selectedRowsData.forEach(element => 
      {
          //console.log(element);  
          
          if(element.userPin === undefined)
          { 
            if(index ==0)
            {
              this.selectedRowsDataDevice = [];
            }
            //si no esta definido en la tabla , es por que es de la tabla de dispositivos
           // console.log(element.deviceSN);
            this.selectedRowsDataDevice.push(element.deviceSN);
            this.userInfoSynchronize.DevicesSN =this.selectedRowsDataDevice;
          }
          else
          {
           //si es la primera vez que entra 
           if(index ==0)
           {
             this.selectedRowsDataUser = [];
             this.selectedUser.userName = element.userName;
             this.selectedUser.privilege = element.privilege;
             this.selectedUser.userPin = element.userPin;
             //solo tomar los datos importantes del primer usuario
             //esto para enviarlo a sincronizar.
           }
            this.selectedRowsDataUser.push(element.userPin);
            this.userInfoSynchronize.UserPin = this.selectedRowsDataUser;
          }
          index ++;
      });   
  }
  onValueChangedDateStart(e:any)
  {
      //this.IUserMSGModel.startTime = new Date(); 
      //this.IUserMSGModel.startTime.setDate( (this.IUserMSGModel.startTime.getDate()+ 30));
  }
  
  showBioTemplates(e){
    //console.log(e);
    //console.log(e.row.key.userPin);
    var userPin = e.row.key.userPin;
    this.bUserPIN = userPin;
    this.popupBioTemplate=true;
    this.loadBioTemplates(userPin);
  }
}
